import React, { useContext, useEffect } from "react";
import axios from "axios";
// mui
import Grid from "@mui/material/Grid";
// utils
import ApiUrls from "../../../../../../../../../../api/project/ApiUrls";
import { StoreContext } from "../../../../../../../../../../store/StoreProvider";
import Act from "../../../../../../../../../../store/actions";
// component
import MainRight from "./right/MainRight";
import MainLeft from "./left/MainLeft";

const Main = () => {
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { uid } = user;
  const events = sna.filter.eventTypes.initial;

  const handleFetch = async (text) => {
    localStorage.setItem("AIFetch", true);

    const foundMainEvn = events
      .filter((e) => e.pid === "EVTTYPE0")
      .map((el) => el.name);

    try {
      await axios.post(ApiUrls.getAIAnalyze(), {
        username: uid,
        content: text,
        mainEvn: foundMainEvn,
      });
    } catch (e) {
      dispatch({
        type: Act.COMMON_SET_ERROR_MESSAGE,
        payload: {
          open: true,
          content: "Fail to Fetch data",
        },
      });
    }
  };

  const getLocalStorage = localStorage.getItem("AIFetch");

  useEffect(() => {
    if (getLocalStorage === "true") {
      dispatch({ type: Act.SNA_SET_AI_IS_FETCH_DATA, payload: true });
      dispatch({ type: Act.SNA_SET_AI_CURRENT_PAGE, payload: "result" });
    }
  }, []);

  return (
    <Grid container>
      <MainLeft />
      <MainRight handleFetch={handleFetch} />
    </Grid>
  );
};

export default Main;
